/* src/app/shared/components/new-drawer/search/components/recipients-search/recipients-search-form.component.scss */
:host {
  display: flex;
  flex: 1;
}
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
}
.container__form {
  flex: 1;
}
.container__buttons-wrapper {
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 1rem;
}
/*# sourceMappingURL=recipients-search-form.component.css.map */
